import { useAtom } from "jotai";

import { ContentWrapper, PaddingConfig } from "components/ContentWrapper";

import { tokenAtom } from "../../atoms/accountAtom";
import {
  setConfirmationModalAtom,
  setModalCloseAtom,
} from "../../atoms/modalAtom/modalAtom";

import { MenuItem } from "./MenuItem";

const BOTTOM_MENU_PADDING_CONFIG: PaddingConfig = {
  paddingLeft: 24,
  paddingTop: 20,
  paddingBottom: 24,
  paddingRight: 52,
};

export const BottomMenu = (): JSX.Element => {
  const [, setToken] = useAtom(tokenAtom);
  const [, setConfirmationModal] = useAtom(setConfirmationModalAtom);
  const [, setModalClose] = useAtom(setModalCloseAtom);

  const onLogoutClick = () => {
    setConfirmationModal({
      title: "Вы уверены, что хотите выйти?",
      confirmText: "Выйти",
      onConfirm: () => {
        setToken("");
        localStorage.removeItem("token");
        setModalClose();
      },
    });
  };

  return (
    <ContentWrapper paddingConfig={BOTTOM_MENU_PADDING_CONFIG}>
      <MenuItem name="Помощь" icon="help" />
      <MenuItem name="Настройки" icon="settings" />
      <MenuItem name="Выйти" icon={"logout"} onClick={onLogoutClick} />
    </ContentWrapper>
  );
};
